export default __webpack_public_path__ + "static/media/business-license-image-2.4d78d203.png";